import logo from './logo.svg';
import './App.css';
import { useState, useDimensions, useEffect } from "react"
import PageHeader from './Components/Header';
import ActionCard from './Components/ActionCard';
import PlanManagment from './Pages/PlanManagmentPage';
import UserCount from './Components/TsComponent';
import OptionListMgnmtPage from './Pages/OptionListManagmentPage';
import LoginPage from './Pages/LoginPage';
import WelcomeDashboard from './Pages/WelcomeDashboard';
import FinancialDashboard from './Pages/FinancialDashboard';
import UserDashboard from './Pages/UserManagment/UserManagment';
import SubscriptionDashboard from './Pages/SubscriptionDashboard';
import EntitlementEngineDashboard from './Pages/EntitlementEngineDashboard';
import EmailDashboard from './Pages/EmailsDashboard';
import TopNavBar from './Components/NavBar';
import { useCookies } from 'react-cookie';

const MOCK_FINANCIALS = {
  totalUsersEnrolled: [
    {
      title: "Basic Plan",
      totalSoFarEurCents: 1250000,
      perUnitMonthlyValueEuroCents: 995,
      totalMonthlyValueEuroCents: 99500
    },
    {
      title: "Premium Plan",
      totalSoFarEurCents: 3450000,
      perUnitMonthlyValueEuroCents: 1995,
      totalMonthlyValueEuroCents: 199500
    }
  ],
  earningsPerMonth: [
    { month: "Jan", title: "Basic Plan", totalInEurCents: 45000 },
    { month: "Jan", title: "Premium Plan", totalInEurCents: 80000 },
    { month: "Feb", title: "Basic Plan", totalInEurCents: 52000 },
    { month: "Feb", title: "Premium Plan", totalInEurCents: 90000 },
    { month: "Mar", title: "Basic Plan", totalInEurCents: 58500 },
    { month: "Mar", title: "Premium Plan", totalInEurCents: 110000 }
  ]
};


function App() {
  const [text, setText] = useState("");
  const [cookies] = useCookies();
  const [page, setPage] = useState("root");

  /*  useEffect(() => {
     const style = document.createElement("style");
     style.innerHTML = "href='./output.css' rel='stylesheet'"
     document.head.appendChild(style)
   }, []) */

  useEffect(() => {
    if (cookies.accessToken) {
      setPage("dashboard");
    }
  }, [])

  function renderPage(page) {
    switch (page) {
      case "user":
        return <UserDashboard />;
      case "dashboard":
        return <WelcomeDashboard />
      case "financial":
        return <FinancialDashboard financialsData={MOCK_FINANCIALS} />
      case "plans":
        return <PlanManagment />;
      case "pwreset":
        return null;
      case "option_lists":
        return <OptionListMgnmtPage />
      case "subscription":
        return <SubscriptionDashboard />
      case "engine":
        return <EntitlementEngineDashboard />;
      case "emails":
        return <EmailDashboard />
      default:
        return <LoginPage onLoginSucessfull={() => setPage("dashboard")} />;
    }
  }



  function renderMenu() {
    return (
      <div style={{ display: "flex", flexDirection: "row", flexWrap: "wrap", justifyContent: "space-evenly" }} >

      </div>
    )
  }

  return (<div>
    {page != "root" && <TopNavBar activePage={page} onPageChange={selection => setPage(selection)} />}
    {renderPage(page)}
  </div>)
}

export default App;
